export default __webpack_public_path__ + "static/media/QKC-BUSD.5b3900be.svg";